import { get } from './http'

const ShootOnOppo = {
  // 获取拍摄横幅
  getBanner: () => {
    return get('/operating-platform/campaign/frontend/photography/getBanner')
  },
  // 获取拍摄横幅
  getHistoryList: () => {
    return get('/operating-platform/campaign/frontend/photography/getPreviousList')
  },
  // 获取拍摄活动信息
  getShootInfo: (params) => {
    return get('/operating-platform/campaign/frontend/photography/getActivityContent', params)
  },
  // 获取拍摄高光列表
  getRecentList: (params) => {
    return get('/operating-platform/campaign/frontend/photography/getsContentByLabel', params)
  },
}


export default ShootOnOppo